// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementSparseSegmentsDataResult = objectOf({
  segments: arrayOf(
    objectOf({
      id: string,
      name: string,
      app_group_id: string,
      is_archived: boolean,
      is_global_control: boolean,
    })
  ),
});
